// extracted by mini-css-extract-plugin
export default {"changedColumn":"index_changedColumn__wg-WJ"};